import { useGetCompaniesQuery } from "./companiesApiSlice"
import Company from "./Company"
import useAuth from "../../hooks/useAuth"
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link,  useParams } from "react-router-dom"

const CompaniesList = () => {
    useTitle('techCompanies: Companies List')
    const {groupId, type} = useParams()
     const { username, isManager, isAdmin } = useAuth()

    const {
        data: companies,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetCompaniesQuery('companiesList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {
        const { ids, entities } = companies

            const tableContent = ids.map(companyId => <Company key={companyId} companyId={companyId} />)

        content = (
            <>
                    <Link to={`/${type}/${groupId}/companies/new`}>
 <FontAwesomeIcon icon={faAdd} />הוספת חברה
        </Link>
        <table className="table table--companies">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th company__name">Name</th>
                        <th scope="col" className="table__th company__active">Active</th>
                        <th scope="col" className="table__th company__edit">Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
          
        )
    }

    return content
}
export default CompaniesList